import { useState } from "react"
import KnownPainsModal from "@/components/KnownPainsModal/KnownPainsModal"
import {
  loadedPains,
  painsActionLine,
  painsCountLine,
  painsLabel,
  RULES_COPY,
} from "@/content/sessionRules"
import styles from "@/styles/components/SessionRules.module.css"

/** What the client already told the facilitator. Opens the note dialog. */
interface KnownPainsProps {
  sessionId: string
  notes: string[]
}

export default function KnownPains({ sessionId, notes }: KnownPainsProps) {
  const [open, setOpen] = useState(false)
  const loaded = loadedPains(notes)

  return (
    <section className={`${styles.block} ${styles.knownPains}`}>
      <div className={styles.blockHead}>
        <span className={styles.label}>{RULES_COPY.knownPains}</span>
        <span className={styles.meta}>{painsLabel(loaded)}</span>
      </div>

      <button type="button" className={styles.pains} onClick={() => setOpen(true)}>
        <span className={styles.painNotes} aria-hidden="true">
          <span className={styles.painNoteA} />
          <span className={styles.painNoteB} />
        </span>
        <span className={styles.painText}>
          <span className={styles.painCount}>{painsCountLine(loaded)}</span>
          <span className={styles.hint}>{painsActionLine(loaded)}</span>
        </span>
        <span className={styles.painArrow} aria-hidden="true">
          →
        </span>
      </button>

      <p className={styles.hint}>{RULES_COPY.painsHint}</p>

      {open ? (
        <KnownPainsModal sessionId={sessionId} notes={notes} onClose={() => setOpen(false)} />
      ) : null}
    </section>
  )
}
